import { removeClass } from '@opten/dom/remove-class';
import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';

@Component({ className: 'js-sticky' })
export class StickyComponent {
	private ignoreObserver = false;
	constructor(private element: HTMLElement) {
		const observer = new IntersectionObserver(
			([e]) => {
				if (this.ignoreObserver === false && e.boundingClientRect.top < 200) {
					if (e.intersectionRatio < 1) {
						addClass(element, 'is-sticky');
						this.ignoreObserver = true;
					} else {
						removeClass(element, 'is-sticky');
						this.ignoreObserver = false;
					}
					setTimeout(() => {
						this.ignoreObserver = false;
					}, 300);
				}
			},
			{
				threshold: [1],
				rootMargin: '-20px 0px 0px 0px',
			}
		);

		observer.observe(element);
	}
}
